import { createSelector } from "@reduxjs/toolkit";

import type { TopicCaseStudy } from "domains/caseStudy/types";
import type { RootState } from "types";

export const getCaseStudyById = (id: string) => (state: RootState) => state.domains.caseStudies.byId[id];

export const createCaseStudiesSelector = (ids: string[]) =>
  createSelector(...ids.map(getCaseStudyById), (...caseStudies) => caseStudies.filter((item) => item !== undefined));

export const createCaseStudiesForTopicSelector = (id: string) => (state: RootState) =>
  (state.domains.caseStudies.forTopic as Partial<Record<string, TopicCaseStudy>>)[id];
